<template>
  <div :class="$style.tooltipWrapper">
    <TenantPlusBadge :class="$style.badge" />
    <HgTooltip v-if="showTooltip" :class="$style.tooltip" theme="light" @click="trackOpenTooltip">
      {{ t('moreImages.tenantPlus.tooltip.text') }}
    </HgTooltip>
  </div>
</template>

<script lang="ts" setup>
import TenantPlusBadge from '@/components/TenantPlus/Badge/TenantPlusBadge.vue';
import { HgTooltip } from '@smg-real-estate/domus';

import { EventLabel, InteractionEvent, InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'ExclusiveImageBadge',
});

interface Props {
  showTooltip?: boolean;
}

withDefaults(defineProps<Props>(), {
  showTooltip: false,
});

const { t } = useI18n();

const trackOpenTooltip = (): void => {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: InteractionGoal.OPEN_TOOLTIP,
    h_event_label_008: EventLabel.VIEW_BLURRY_IMAGE_PDP,
  });
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

.badge {
  align-items: center;
  margin: 0;
}
.tooltip {
  padding: 0 0 0 $space-50;
}
.tooltipWrapper {
  display: flex;
  align-items: center;
}
</style>
